import { render, staticRenderFns } from "./MicroCredentialSettings.vue?vue&type=template&id=df180b7a"
import script from "./MicroCredentialSettings.vue?vue&type=script&lang=js"
export * from "./MicroCredentialSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports